import RevenueSvg from 'assets/icons/navigation/revenue.svg?react';

import { createAntdIcon } from 'components/icons/createAntdIcon';

export default createAntdIcon(RevenueSvg, { displayName: 'RevenueIcon' });
